import { render } from "./ConsultationDetail.vue?vue&type=template&id=d8fb5778&scoped=true"
import script from "./ConsultationDetail.vue?vue&type=script&lang=js"
export * from "./ConsultationDetail.vue?vue&type=script&lang=js"

import "./ConsultationDetail.vue?vue&type=style&index=0&id=d8fb5778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8fb5778"]])

export default __exports__